export const sacTags = {
  1: 'Avariado',
  2: 'Reembalado',
  3: 'Última Oportunidade',
  4: 'Regular',
};
